import { useProfile } from 'init/index';
import type { PropsWithChildren } from 'react';

type SuperUserOnlyrops = PropsWithChildren<{}>;

export const SuperUserOnly = ({ children }: SuperUserOnlyrops) => {
  const profile = useProfile();

  if (profile.isSuperAdmin) return children;
  return null;
};
